import api from '../api/api';
import { RolePermissionsMatrix } from '../../types/RolePermission';

class RolePermissionsService {
  static async getRolePermissions(
    signal?: AbortSignal
  ): Promise<RolePermissionsMatrix> {
    const apiResponse = await api.get('/role-permissions', { signal });
    return apiResponse.data;
  }
}

export default RolePermissionsService;
